export const PAYMENT_CURRENCY = [
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" },
  { label: "KZT", value: "KZT" },
  { label: "RUB", value: "RUB" },
  { label: "UAH", value: "UAH" }
];
